<template>
  <el-dialog
    append-to-body
    width="600px"
    title=""
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <template #title>
      <div class="el-dialog-title">投递进度</div>
    </template>
    <el-steps direction="vertical" :active="log.length" style="width: 100%">
      <el-step v-for="(item, index) in log" :key="index">
        <template v-if="item.process == 3">
          <template slot="title">
            <span>{{ item.text }}</span>
          </template>
          <template slot="description">
            <span>{{ item.time }}</span>
            <div
              style="
                border: 1px solid #e0e0e0;
                background: #f9f9f9;
                padding: 10px 10px;
                word-wrap: break-word;
                word-break: break-all;
                width:470px;
                box-sizing: border-box;
              "
            >
              <div>面试时间:{{ item.info.interview_time }}</div>
              <div>
                面试地址:
                {{ `${info.province}${info.city}${info.area}${info.address}` }}
              </div>
            </div>
          </template>
        </template>
        <template v-else-if="item.process == 5">
          <template slot="title">
            <span>{{ item.text }}</span>
          </template>
          <template slot="description">
            <span>{{ item.time }}</span>
            <div
              style="
                padding: 10px 10px;
                word-wrap: break-word;
                word-break: break-all;
                width:470px;
                box-sizing: border-box;
                border: 1px solid #e0e0e0;
                background: #f9f9f9;
              "
            >
              <div style="margin: 0; line-height: 1.5;">
                <div 
                  :style="!item.expanded && item.hasMoreLines ? {
                    display: '-webkit-box',
                    '-webkit-line-clamp': '2',
                    '-webkit-box-orient': 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  } : {}"
                  v-html="formattedText(item.displayText || item.info.offer_tips)"
                ></div>
                <el-button 
                  v-if="item.hasMoreLines" 
                  type="text" 
                  @click="toggleExpand(item)"
                  style="padding: 0; margin-top: 5px;"
                >
                  {{ item.expanded ? '收起' : '展开' }}
                </el-button>
              </div>
            </div>
          </template>
        </template>
        <template v-else-if="item.process == 9">
           <template slot="title">
             <span>{{ item.text }}</span>
           </template>
           <template slot="description">
             <span>{{ item.time }}</span>
             <div>{{item.info.offer_abandon_reason}}</div>
           </template>
        </template>
        <template v-else>
          <template slot="title">
            <span>{{ item.text }}</span>
          </template>
          <template slot="description">
            <span>{{ item.time }}</span>
             <div v-if="item.process == 8">对方已开通诚信保,若对方单方面违约可向平台反馈,平台将会取消对方诚信保资格。</div>
          </template>
        </template>
      </el-step>
    </el-steps>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button @click="toggle(false)">关闭</el-button>
      </el-row>
    </template>
  </el-dialog>
</template>
<script>
import { mixinTable } from "@/mixins/tableCompany.js";
export default {
  mixins: [mixinTable],
  data() {
    return {
      visible: false,
      currentRow: {},
      info: {},
      log: [],

    };
  },
  created() {},
  methods: {
    formattedText(val) {
      return val.replace(/\n/g, '<br>');
    },
    toggleExpand(item) {
      if (item.expanded) {
        // 收起：应用两行限制的样式
        this.$set(item, 'displayText', item.originalText);
        this.$set(item, 'expanded', false);
        this.$nextTick(() => {
          this.applyTwoLineLimit(item);
        });
      } else {
        // 展开：显示全部内容
        this.$set(item, 'displayText', item.originalText);
        this.$set(item, 'expanded', true);
      }
    },
    measureTextLines() {
      this.log.forEach((item, index) => {
        if (item.process === 5 && item.info && item.info.offer_tips) {
          // 创建临时元素来测量
          const tempDiv = document.createElement('div');
          tempDiv.style.cssText = `
            position: absolute;
            visibility: hidden;
            width: 450px;
            font-size: 14px;
            line-height: 1.5;
            word-wrap: break-word;
            word-break: break-all;
            white-space: pre-wrap;
            padding: 10px;
            box-sizing: border-box;
          `;
          tempDiv.textContent = item.originalText;
          document.body.appendChild(tempDiv);
          
          const lineHeight = 21; // 14px * 1.5
          const actualHeight = tempDiv.offsetHeight;
          const lines = Math.ceil(actualHeight / lineHeight);
          
          document.body.removeChild(tempDiv);
          
          this.$set(item, 'hasMoreLines', lines > 2);
          if (lines > 2) {
            this.applyTwoLineLimit(item);
          }
        }
      });
    },
    applyTwoLineLimit(item) {
      // 临时创建元素来找到合适的截断点
      const tempDiv = document.createElement('div');
      tempDiv.style.cssText = `
        position: absolute;
        visibility: hidden;
        width: 450px;
        font-size: 14px;
        line-height: 1.5;
        word-wrap: break-word;
        word-break: break-all;
        white-space: pre-wrap;
        padding: 10px;
        box-sizing: border-box;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      `;
      tempDiv.textContent = item.originalText;
      document.body.appendChild(tempDiv);
      
      const truncatedContent = tempDiv.textContent;
      document.body.removeChild(tempDiv);
      
      this.$set(item, 'displayText', truncatedContent);
    },
    reset(done) {
      if (this.$refs.elFormDom) {
        this.$refs.elFormDom.resetFields();
      }
      this.log = [];
      this.currentRow = {};
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    getdetails(row) {
      this.currentRow = row;
      console.log(this.currentRow,'row')
      this.getInfo();
    },
    getInfo() {
      this.$http
        .get("/company/message/resumeInfo", {
          params: { id: this.currentRow.id },
        })
        .then((res) => {
          if (res.code == 1) {
            this.info = res.data;
            this.log = res.data.log.map(item => {
              if (item.process === 5 && item.info && item.info.offer_tips) {
                return {
                  ...item,
                  expanded: false,
                  hasMoreLines: false,
                  displayText: item.info.offer_tips,
                  originalText: item.info.offer_tips
                };
              }
              return item;
            });
            let addIndex = this.log.findIndex(item => item.process === 3 && item.info && (item.info.status == 1 || item.info.status == 2) );
            let addObj = this.log[addIndex];
            if(addIndex > -1){
              let obj = {
                text: addObj.info.status == 1 ?'对方已接受面试':'对方已拒绝面试',
                time: addObj.info.handle_time,
                process:'需要加长度'
              }
              this.log.splice(addIndex + 1, 0, obj)
            }
            // 等待DOM渲染完成后测量实际行数
            this.$nextTick(() => {
              this.measureTextLines();
            });
            // 简历进度 1:已投递 2:已查看 3:邀面试 4:不合适 5:面试通过 6:面试不通过 8:接受offer 9:放弃offer
          }
        });
    },
  },
};
</script>